// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Badge INSTEAD.
import React, { useRef, useMemo, forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getColorLuma } from "../../../utils/Colors";
var UUBadge = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    className = props.className,
    color = props.color,
    text = props.text,
    badgeAriaLabel = props.badgeAriaLabel,
    dataTestId = props.dataTestId,
    shape = props.shape,
    onClick = props.onClick,
    type = props.type;
  var badgeRef = ref || useRef(null);
  if (!text) {
    return null;
  }
  var getBadgeStyle = function getBadgeStyle() {
    var luma = getColorLuma(color);
    return {
      color: luma < 128 ? 'white' : '#4A657F',
      backgroundColor: type === 'filter' ? 'white' : color
    };
  };
  var badgeBaseClass = 'min-w-24 text-center box-border inline-block text-13px p-1.2';
  var badgeClass = useMemo(function () {
    var baseClass = shape === 'square' ? 'leading-7.5 h-10 rounded-none font-bold px-2.5' : 'leading-2 h-6 rounded-xl';
    return classNames(badgeBaseClass, baseClass, {
      'border-solid border border-brand-blue rounded-6 h-6': type === 'filter'
    }, className);
  }, [shape, className, type]);
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (onClick) {
        onClick(e);
      }
    } else if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
      e.preventDefault();
    }
  };
  return /*#__PURE__*/React.createElement("span", {
    id: id,
    className: badgeClass,
    style: getBadgeStyle(),
    "aria-label": "".concat(badgeAriaLabel, ": ").concat(text),
    tabIndex: 0,
    role: "button",
    ref: badgeRef,
    onKeyDown: handleKeyDown,
    "data-testid": dataTestId,
    onClick: onClick,
    type: type
  }, text);
});
UUBadge.propTypes = {
  badgeAriaLabel: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  shape: PropTypes.oneOf(['square', 'circle']),
  dataTestId: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['filter'])
};
UUBadge.defaultProps = {
  badgeAriaLabel: 'Badge',
  id: '',
  className: '',
  style: {},
  shape: 'circle',
  dataTestId: '',
  type: undefined
};
export default UUBadge;